import { apiClient } from "@base/api/client";
import { useSuspenseQuery } from "@tanstack/react-query";
import type { UseSuspenseQueryOptions } from "@tanstack/react-query";

export interface Project {
  id: number;
  name: string;
  thumbnail_image_url: string;
}

interface ProjectsResponse {
  projects: Project[];
}

async function fetchProjects(): Promise<ProjectsResponse> {
  const response = await apiClient.get<ProjectsResponse>("/project-management/api/projects");
  return response.data;
}

export function projectsQueryOptions() {
  return {
    queryKey: ["projects"] as const,
    queryFn: fetchProjects,
  };
}

export function useProjectsQuery(options?: Omit<UseSuspenseQueryOptions<ProjectsResponse>, "queryKey" | "queryFn">) {
  return useSuspenseQuery({ ...projectsQueryOptions(), ...options });
}
